const getProductAssets = (serverAssets) => {
  if (!serverAssets) {
    return [];
  }
  return serverAssets.map((asset) => ({
    name: asset.name,
    sources: asset.sources.map((source) => ({
      uri: source.uri
    }))
  }));
};
export {
  getProductAssets
};
//# sourceMappingURL=get-product-assets.js.map
